/*
 * ALL RIGHTS RESERVED,
 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
 */

import { AuthenticationCheckService } from '../common/authentication/service/AuthenticationCheckService';

/**
 * Angularアプリケーションの構成情報作成
 * 以下の構成情報についてプロバイダー(※）を使用して作成します。
 * 構成情報：(1)URLルーティング設定
 *           (2)$httpサービスにインタセプター設定
 * ※プロバイダーとは、サービスの挙動を変更するためのコンポーネントです。
 * @param $provide モジュールに対してコンポーネントを登録するためのサービス
 * @param $httpProvider $httpサービスにおけるデフォルトの挙動を設定するプロバイダー
 * @param $urlRouterProvider (UI Router)よるルーティングプロバイダー
 * @param $stateProvider（UI Router)よるルーティングプロバイダー
 */
/* @ngInject */
export function config($provide: ng.auto.IProvideService, $httpProvider: ng.IHttpProvider,
                        $urlRouterProvider: ng.ui.IUrlRouterProvider, $stateProvider: ng.ui.IStateProvider): void {
    $stateProvider
        .state('top', {
            url: '/top',
            views: { 'main': { templateProvider: ($translate: ng.translate.ITranslateService, $templateFactory: any, $templateCache: ng.ITemplateCacheService): ng.IPromise<string> => { return getNextTemplate(
                    'template/dashboard/index.html', $templateFactory, $templateCache, $translate); },
                    controller: 'dashboardController',
                    controllerAs: 'dashboard' } }
        }).state('login', {
            url: '/',
            views: { 'main': { templateProvider: ($translate: ng.translate.ITranslateService, $templateFactory: any, $templateCache: ng.ITemplateCacheService): ng.IPromise<string> => { return getNextTemplate(
                    'template/login/index.html', $templateFactory, $templateCache, $translate); },
                    controller: 'loginController',
                    controllerAs: 'login' } }
        }).state('loginPassword', {
            url: '/loginPassword',
            views: { 'main': { templateProvider: ($translate: ng.translate.ITranslateService, $templateFactory: any, $templateCache: ng.ITemplateCacheService): ng.IPromise<string> => { return getNextTemplate(
                    'template/loginPassword/index.html', $templateFactory, $templateCache, $translate); },
                    controller: 'loginPasswordController',
                    controllerAs: 'loginPassword' } }
        }).state('user', {
            url: '/user',
            views: { 'main': { templateProvider: ($translate: ng.translate.ITranslateService, $templateFactory: any, $templateCache: ng.ITemplateCacheService): ng.IPromise<string> => { return getNextTemplate(
                    'template/user/index.html', $templateFactory, $templateCache, $translate); },
                    controller: 'userController',
                    controllerAs: 'user' } }
        }).state('viewingHistory', {
            url: '/history/:page/:name',
            views: { 'main': { templateProvider: ($translate: ng.translate.ITranslateService, $templateFactory: any, $templateCache: ng.ITemplateCacheService): ng.IPromise<string> => { return getNextTemplate(
                    'template/viewingHistory/index.html', $templateFactory, $templateCache, $translate); },
                    controller: 'viewingHistoryController',
                    controllerAs: 'viewingHistory' } }
        }).state('company', {
            url: '/company',
            views: { 'main': { templateProvider: ($translate: ng.translate.ITranslateService, $templateFactory: any, $templateCache: ng.ITemplateCacheService): ng.IPromise<string> => { return getNextTemplate(
                    'template/company/index.html', $templateFactory, $templateCache, $translate); },
                    controller: 'companyController',
                    controllerAs: 'company' } }
        }).state('group', {
            url: '/group',
            views: { 'main': { templateProvider: ($translate: ng.translate.ITranslateService, $templateFactory: any, $templateCache: ng.ITemplateCacheService): ng.IPromise<string> => { return getNextTemplate(
                    'template/group/index.html', $templateFactory, $templateCache, $translate); },
                    controller: 'groupController',
                    controllerAs: 'group' } }
        }).state('video', {
            url: '/video',
            views: { 'main': { templateProvider: ($translate: ng.translate.ITranslateService, $templateFactory: any, $templateCache: ng.ITemplateCacheService): ng.IPromise<string> => { return getNextTemplate(
                    'template/video/index.html', $templateFactory, $templateCache, $translate); },
                    controller: 'videoController',
                    controllerAs: 'video' } }
        }).state('category', {
            url: '/category',
            views: { 'main': { templateProvider: ($translate: ng.translate.ITranslateService, $templateFactory: any, $templateCache: ng.ITemplateCacheService): ng.IPromise<string> => { return getNextTemplate(
                    'template/category/index.html', $templateFactory, $templateCache, $translate); },
                    controller: 'categoryController',
                    controllerAs: 'category' } }
        }).state('recommend', {
            url: '/recommend',
            views: { 'main': { templateProvider: ($translate: ng.translate.ITranslateService, $templateFactory: any, $templateCache: ng.ITemplateCacheService): ng.IPromise<string> => { return getNextTemplate(
                    'template/recommend/index.html', $templateFactory, $templateCache, $translate); },
                    controller: 'recommendController',
                    controllerAs: 'recommend' } }
        }).state('series', {
            url: '/series',
            views: { 'main': { templateProvider: ($translate: ng.translate.ITranslateService, $templateFactory: any, $templateCache: ng.ITemplateCacheService): ng.IPromise<string> => { return getNextTemplate(
                    'template/series/index.html', $templateFactory, $templateCache, $translate); },
                    controller: 'seriesController',
                    controllerAs: 'series' } }
        }).state('pack', {
            url: '/pack',
            views: { 'main': { templateProvider: ($translate: ng.translate.ITranslateService, $templateFactory: any, $templateCache: ng.ITemplateCacheService): ng.IPromise<string> => { return getNextTemplate(
                    'template/pack/index.html', $templateFactory, $templateCache, $translate); },
                    controller: 'packController',
                    controllerAs: 'pack' } }
        }).state('notice', {
            url: '/notice',
            views: { 'main': { templateProvider: ($translate: ng.translate.ITranslateService, $templateFactory: any, $templateCache: ng.ITemplateCacheService): ng.IPromise<string> => { return getNextTemplate(
                    'template/notice/index.html', $templateFactory, $templateCache, $translate); },
                    controller: 'noticeController',
                    controllerAs: 'notice' } }
        }).state('userCap', {
            url: '/userCap',
            views: { 'main': { templateProvider: ($translate: ng.translate.ITranslateService, $templateFactory: any, $templateCache: ng.ITemplateCacheService): ng.IPromise<string> => { return getNextTemplate(
                    'template/userCap/index.html', $templateFactory, $templateCache, $translate); },
                    controller: 'userCapController',
                    controllerAs: 'userCap' } }
        }).state('password', {
            url: '/password',
            views: { 'main': { templateProvider: ($translate: ng.translate.ITranslateService, $templateFactory: any, $templateCache: ng.ITemplateCacheService): ng.IPromise<string> => { return getNextTemplate(
                    'template/password/index.html', $templateFactory, $templateCache, $translate); },
                    controller: 'passwordController',
                    controllerAs: 'password' } }
        }).state('blank', {
            url: '/blank/:go',
            views: { 'main': { templateProvider: ($translate: ng.translate.ITranslateService, $templateFactory: any, $templateCache: ng.ITemplateCacheService): ng.IPromise<string> => { return getNextTemplate(
                    'template/blank/index.html', $templateFactory, $templateCache, $translate); },
                    controller: 'blankController',
                    controllerAs: 'blank' } }
        }).state('ERROR', {
            url: '/error',
            params: {
                code: null, // エラーコード
                msg: null // エラーメッセージ
            },
            views: {
                'main': {
                    templateProvider: ($translate: ng.translate.ITranslateService,
                                       $templateFactory: any,
                                       $templateCache: ng.ITemplateCacheService): ng.IPromise<string> => {
                        return getNextTemplate('../common/error/template/SystemError.html',
                                               $templateFactory, $templateCache, $translate);
                    },
                    controller: 'SystemErrorController',
                    controllerAs: 'error'
                }
            }
        });
}
/**
 * テンプレートの取得処理（テンプレートキャッシュの利用が前提）
 * 指定されたロケールのテンプレートを取得する。
 * 指定したロケールのテンプレートが存在しない場合は、プレフィックスなしのテンプレート→fallbackLanguageのテンプレートの順に取得する。
 * @param {string} templateUrl テンプレートのURL(プレフィックスなし)
 * @param {any} $templateFactory UI Routerのテンプレート管理サービス
 * @param {ng.ITemplateCacheService} $templateCache AngularJSのテンプレートキャッシュの管理サービス
 * @param {ng.translate.ITranslateService} $translate Angular Translaeのサービス
 * @param {authenticationCheckService} AuthenticationCheckService 認証チェック部品
 * @return {string} 表示するテンプレート
 */
function getNextTemplate(templateUrl: string, $templateFactory: any,
                         $templateCache: ng.ITemplateCacheService,
                         $translate: ng.translate.ITranslateService,
                         authenticationCheckService?: AuthenticationCheckService): ng.IPromise<string> {
    let str: string[] = templateUrl.split('.');
    let translate: string = str[0] + '_' + $translate.use() + '.' + str[1];
    let url: string = null;
    // 指定ロケールのテンプレートの有無のチェック
    if ($templateCache.get(translate)) {
        // 指定ロケールのプレフィックスのファイルを使用
        url = translate;
    } else {
        // プレフィックスなしのテンプレートの有無チェック
        if ($templateCache.get(templateUrl)) {
            // プレフィックスなしのテンプレートを使用
            url = templateUrl;
        } else {
            // fallbackLanguageのロケールをプレフィックスとするテンプレートを使用
            let locals: any = $translate.fallbackLanguage();
            if (Array.isArray(locals)) {
                // 配列の場合
                for (let i: number = 0; i < locals.length; i++) {
                    let fallback: string =  str[0] + '_' + locals[i] + '.' + str[1];
                    if ($templateCache.get(fallback)) {
                        url = fallback;
                        break;
                    }
                }
            } else {
                // 文字列の場合
                let fallback: string = str[0] + '_' + locals + '.' + str[1];
                if ($templateCache.get(fallback)) {
                    url = fallback;
                }
            }
        }
    }
    if (url) {
        // 適切なテンプレートがある場合
        if (authenticationCheckService) {
            return authenticationCheckService.isAuthenticated(url);
        } else {
            return $templateFactory.fromUrl(url);
        }
    } else {
        // テンプレートが無い場合（アプリケーションの不具合のため、開発者への通知用）
        // テンプレートキャッシュを前提としているため、通信状況によりテンプレートが取得できないという問題はない
        console.error(templateUrl + 'のテンプレートが存在しません');
        alert(templateUrl + 'のテンプレートが存在しません');
    }
}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/ma/router.ts
 **/